import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/shijisun/edu/projects/imui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Dropdown from './index';
import DropdownOption from './lib/DropdownOption';
import Button from '../button/index';
import Icon from '../icon/index';
import { Playground, Props } from 'docz';
import './style/index.scss';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "dropdown"
    }}>{`Dropdown`}</h1>

    <h2 {...{
      "id": "props--methods"
    }}>{`Props & Methods`}</h2>
    <Props of={Dropdown} mdxType="Props" />
    <h3 {...{
      "id": "-options"
    }}>{`👆 options`}</h3>
    <Props of={DropdownOption} mdxType="Props" />
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h2>
    <Playground __position={2} __code={'<Dropdown\n  options={[{ value: \'Apple\' }, { value: \'Banana\' }, { value: \'Coconut\' }]}\n  style={{ width: \'200px\' }}\n/>'} __scope={{
      props,
      DefaultLayout,
      Dropdown,
      DropdownOption,
      Button,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Dropdown options={[{
        value: 'Apple'
      }, {
        value: 'Banana'
      }, {
        value: 'Coconut'
      }]} style={{
        width: '200px'
      }} mdxType="Dropdown" />
    </Playground>
    <h2 {...{
      "id": "placeholder"
    }}>{`Placeholder`}</h2>
    <Playground __position={3} __code={'<Dropdown\n  options={[{ value: \'Apple\' }, { value: \'Banana\' }, { value: \'Coconut\' }]}\n  style={{ width: \'200px\' }}\n  placeholder=\"I am the placeholder\"\n/>'} __scope={{
      props,
      DefaultLayout,
      Dropdown,
      DropdownOption,
      Button,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      <Dropdown options={[{
        value: 'Apple'
      }, {
        value: 'Banana'
      }, {
        value: 'Coconut'
      }]} style={{
        width: '200px'
      }} placeholder="I am the placeholder" mdxType="Dropdown" />
    </Playground>
    <h2 {...{
      "id": "display-variants"
    }}>{`Display Variants`}</h2>
    <Playground __position={4} __code={'<Dropdown\n  options={[{ value: \'Apple\' }, { value: \'Banana\' }, { value: \'Coconut\' }]}\n  style={{ width: \'200px\' }}\n  placeholder=\"I am cleanable\"\n  cleanable\n/>\n<span style={{ display: \'inline-block\', width: \'15px\' }}></span>\n<Dropdown\n  options={[{ value: \'Apple\' }, { value: \'Banana\' }, { value: \'Coconut\' }]}\n  placeholder={\'No icon on the right!\'}\n  style={{ width: \'200px\' }}\n  noIcon\n/>\n<span style={{ display: \'inline-block\', width: \'15px\' }}></span>\n<Dropdown\n  options={[{ value: \'Apple\' }, { value: \'Banana\' }, { value: \'Coconut\' }]}\n  placeholder={\'No border around!\'}\n  style={{ width: \'200px\' }}\n  noBorder\n/>\n<span style={{ display: \'inline-block\', width: \'15px\' }}></span>\n<Dropdown\n  options={[{ value: \'Apple\' }, { value: \'Banana\' }, { value: \'Coconut\' }]}\n  placeholder={\'Selected icon shows!\'}\n  showSelectedIcon\n  style={{ width: \'200px\' }}\n/>\n<span style={{ display: \'inline-block\', width: \'15px\' }}></span>\n<Dropdown\n  options={[{ value: \'Apple\' }, { value: \'Banana\' }, { value: \'Coconut\' }]}\n  placeholder={\'I am disabled\'}\n  style={{ width: \'200px\' }}\n  disabled\n/>'} __scope={{
      props,
      DefaultLayout,
      Dropdown,
      DropdownOption,
      Button,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Dropdown options={[{
        value: 'Apple'
      }, {
        value: 'Banana'
      }, {
        value: 'Coconut'
      }]} style={{
        width: '200px'
      }} placeholder="I am cleanable" cleanable mdxType="Dropdown" />
    <span style={{
        display: 'inline-block',
        width: '15px'
      }}></span>
    <Dropdown options={[{
        value: 'Apple'
      }, {
        value: 'Banana'
      }, {
        value: 'Coconut'
      }]} placeholder={'No icon on the right!'} style={{
        width: '200px'
      }} noIcon mdxType="Dropdown" />
    <span style={{
        display: 'inline-block',
        width: '15px'
      }}></span>
    <Dropdown options={[{
        value: 'Apple'
      }, {
        value: 'Banana'
      }, {
        value: 'Coconut'
      }]} placeholder={'No border around!'} style={{
        width: '200px'
      }} noBorder mdxType="Dropdown" />
    <span style={{
        display: 'inline-block',
        width: '15px'
      }}></span>
    <Dropdown options={[{
        value: 'Apple'
      }, {
        value: 'Banana'
      }, {
        value: 'Coconut'
      }]} placeholder={'Selected icon shows!'} showSelectedIcon style={{
        width: '200px'
      }} mdxType="Dropdown" />
    <span style={{
        display: 'inline-block',
        width: '15px'
      }}></span>
    <Dropdown options={[{
        value: 'Apple'
      }, {
        value: 'Banana'
      }, {
        value: 'Coconut'
      }]} placeholder={'I am disabled'} style={{
        width: '200px'
      }} disabled mdxType="Dropdown" />
    </Playground>
    <h2 {...{
      "id": "set-width-of-dropdown"
    }}>{`Set Width of Dropdown`}</h2>
    <Playground __position={5} __code={'<Dropdown\n  options={[{ value: \'Apple\' }, { value: \'Banana\' }, { value: \'Coconut\' }]}\n  placeholder={\'A default dropdown!\'}\n  style={{ width: \'200px\' }}\n/>\n<span style={{ display: \'inline-block\', width: \'15px\' }}></span>\n<Dropdown\n  options={[{ value: \'Apple\' }, { value: \'Banana\' }, { value: \'Coconut\' }]}\n  placeholder={\'A narrow dropdown!\'}\n  style={{ width: \'200px\' }}\n  dropdownWidth={100}\n/>\n<span style={{ display: \'inline-block\', width: \'15px\' }}></span>\n<Dropdown\n  options={[{ value: \'Apple\' }, { value: \'Banana\' }, { value: \'Coconut\' }]}\n  placeholder={\'A wide dropdown!\'}\n  style={{ width: \'200px\' }}\n  dropdownWidth={400}\n/>'} __scope={{
      props,
      DefaultLayout,
      Dropdown,
      DropdownOption,
      Button,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Dropdown options={[{
        value: 'Apple'
      }, {
        value: 'Banana'
      }, {
        value: 'Coconut'
      }]} placeholder={'A default dropdown!'} style={{
        width: '200px'
      }} mdxType="Dropdown" />
    <span style={{
        display: 'inline-block',
        width: '15px'
      }}></span>
    <Dropdown options={[{
        value: 'Apple'
      }, {
        value: 'Banana'
      }, {
        value: 'Coconut'
      }]} placeholder={'A narrow dropdown!'} style={{
        width: '200px'
      }} dropdownWidth={100} mdxType="Dropdown" />
    <span style={{
        display: 'inline-block',
        width: '15px'
      }}></span>
    <Dropdown options={[{
        value: 'Apple'
      }, {
        value: 'Banana'
      }, {
        value: 'Coconut'
      }]} placeholder={'A wide dropdown!'} style={{
        width: '200px'
      }} dropdownWidth={400} mdxType="Dropdown" />
    </Playground>
    <h2 {...{
      "id": "hoverable"
    }}>{`Hoverable`}</h2>
    <Playground __position={6} __code={'<Dropdown\n  options={[{ value: \'Apple\' }, { value: \'Banana\' }, { value: \'Coconut\' }]}\n  style={{ width: \'200px\' }}\n  placeholder=\"I am hoverable\"\n  hoverable\n/>'} __scope={{
      props,
      DefaultLayout,
      Dropdown,
      DropdownOption,
      Button,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      <Dropdown options={[{
        value: 'Apple'
      }, {
        value: 'Banana'
      }, {
        value: 'Coconut'
      }]} style={{
        width: '200px'
      }} placeholder="I am hoverable" hoverable mdxType="Dropdown" />
    </Playground>
    <h2 {...{
      "id": "searchable"
    }}>{`Searchable`}</h2>
    <Playground __position={7} __code={'() => {\n  let bigOptions = []\n  for (let i = 0; i < 100; i++) {\n    bigOptions.push({\n      value: i,\n      display: `display${i}`,\n      search: `display${i}`,\n    })\n  }\n  return (\n    <Dropdown\n      options={bigOptions}\n      placeholder={\'Type to search\'}\n      searchable\n      style={{ width: \'200px\' }}\n    />\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Dropdown,
      DropdownOption,
      Button,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        let bigOptions = [];

        for (let i = 0; i < 100; i++) {
          bigOptions.push({
            value: i,
            display: `display${i}`,
            search: `display${i}`
          });
        }

        return <Dropdown options={bigOptions} placeholder={'Type to search'} searchable style={{
          width: '200px'
        }} mdxType="Dropdown" />;
      }}
    </Playground>
    <h2 {...{
      "id": "preset-option"
    }}>{`Preset Option`}</h2>
    <Playground __position={8} __code={'() => {\n  const myOptions = [\n    { value: \'Apple\' },\n    { value: \'Banana\' },\n    { value: \'Coconut\' },\n  ]\n  return (\n    <Dropdown\n      options={myOptions}\n      value={myOptions[0].value}\n      style={{ width: \'200px\' }}\n    />\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Dropdown,
      DropdownOption,
      Button,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        const myOptions = [{
          value: 'Apple'
        }, {
          value: 'Banana'
        }, {
          value: 'Coconut'
        }];
        return <Dropdown options={myOptions} value={myOptions[0].value} style={{
          width: '200px'
        }} mdxType="Dropdown" />;
      }}
    </Playground>
    <h2 {...{
      "id": "async-options"
    }}>{`Async Options`}</h2>
    <Playground __position={9} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.state = {\n        asnycOptions: null,\n      }\n    }\n    render() {\n      return (\n        <>\n          <Dropdown\n            options={this.state.asnycOptions}\n            style={{ width: \'200px\' }}\n          />\n          <span style={{ display: \'inline-block\', width: \'15px\' }}></span>\n          <Button\n            onClick={() => {\n              this.setState({\n                asnycOptions: [\n                  { value: \'Apple\' },\n                  { value: \'Banana\' },\n                  { value: \'Coconut\' },\n                ],\n              })\n            }}\n            size=\"s\"\n          >\n            Click me to load async options\n          </Button>\n        </>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Dropdown,
      DropdownOption,
      Button,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.state = {
              asnycOptions: null
            };
          }

          render() {
            return <>
                <Dropdown options={this.state.asnycOptions} style={{
                width: '200px'
              }} mdxType="Dropdown" />
                <span style={{
                display: 'inline-block',
                width: '15px'
              }}></span>
                <Button onClick={() => {
                this.setState({
                  asnycOptions: [{
                    value: 'Apple'
                  }, {
                    value: 'Banana'
                  }, {
                    value: 'Coconut'
                  }]
                });
              }} size='s' mdxType="Button">Click me to load async options</Button>
            </>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "icon-options"
    }}>{`Icon Options`}</h2>
    <Playground __position={10} __code={'<Dropdown\n  options={[\n    {\n      display: <Icon type=\"add\" />,\n      value: \'1\', // value is for identity\n    },\n    {\n      display: <Icon type=\"alert\" />,\n      value: \'2\',\n    },\n    {\n      display: (\n        <>\n          <Icon type=\"arrow-bottom\" />\n          <span> Hello</span>\n        </>\n      ),\n      value: \'3\',\n    },\n  ]}\n  placeholder={\'Options with Icon!\'}\n  style={{ width: \'200px\' }}\n/>'} __scope={{
      props,
      DefaultLayout,
      Dropdown,
      DropdownOption,
      Button,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Dropdown options={[{
        display: <Icon type="add" mdxType="Icon" />,
        value: '1' // value is for identity

      }, {
        display: <Icon type="alert" mdxType="Icon" />,
        value: '2'
      }, {
        display: <><Icon type="arrow-bottom" mdxType="Icon" /><span> Hello</span></>,
        value: '3'
      }]} placeholder={'Options with Icon!'} style={{
        width: '200px'
      }} mdxType="Dropdown" />
    </Playground>
    <h2 {...{
      "id": "group-options"
    }}>{`Group Options`}</h2>
    <Playground __position={11} __code={'() => {\n  const groupOptions = [\n    {\n      label: \'热门城市\',\n      options: [\n        {\n          value: \'Beijing\',\n          display: \'北京\',\n          search: \'北京\',\n        },\n        {\n          value: \'Shanghai\',\n          display: \'上海\',\n          search: \'上海\',\n        },\n        {\n          value: \'Guangzhou\',\n          display: \'广州\',\n          search: \'广州\',\n        },\n      ],\n    },\n    {\n      label: \'城市名\',\n      options: [\n        {\n          value: \'Chengdu\',\n          display: \'成都\',\n          search: \'成都\',\n        },\n        {\n          value: \'Shenzhen\',\n          display: \'深圳\',\n          search: \'深圳\',\n        },\n        {\n          value: \'Guangzhou\',\n          display: \'广州\',\n          search: \'广州\',\n        },\n        {\n          value: \'Hangzhou\',\n          display: \'杭州\',\n          search: \'杭州\',\n        },\n      ],\n    },\n  ]\n  return (\n    <Dropdown\n      options={groupOptions}\n      placeholder={\'Options with Group!\'}\n      style={{ width: \'200px\' }}\n      searchable\n    />\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Dropdown,
      DropdownOption,
      Button,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        const groupOptions = [{
          label: '热门城市',
          options: [{
            value: 'Beijing',
            display: '北京',
            search: '北京'
          }, {
            value: 'Shanghai',
            display: '上海',
            search: '上海'
          }, {
            value: 'Guangzhou',
            display: '广州',
            search: '广州'
          }]
        }, {
          label: '城市名',
          options: [{
            value: 'Chengdu',
            display: '成都',
            search: '成都'
          }, {
            value: 'Shenzhen',
            display: '深圳',
            search: '深圳'
          }, {
            value: 'Guangzhou',
            display: '广州',
            search: '广州'
          }, {
            value: 'Hangzhou',
            display: '杭州',
            search: '杭州'
          }]
        }];
        return <Dropdown options={groupOptions} placeholder={'Options with Group!'} style={{
          width: '200px'
        }} searchable mdxType="Dropdown" />;
      }}
    </Playground>
    <h2 {...{
      "id": "customized-options-template"
    }}>{`Customized Options Template`}</h2>
    <Playground __position={12} __code={'() => {\n  const options = [\n    { value: \'Apple\' },\n    { value: \'Banana\' },\n    { value: \'Coconut\' },\n  ]\n  const groupOptions = [\n    {\n      label: \'热门城市\',\n      options: [\n        {\n          value: \'Beijing\',\n          display: \'北京\',\n          search: \'北京\',\n        },\n        {\n          value: \'Shanghai\',\n          display: \'上海\',\n          search: \'上海\',\n        },\n        {\n          value: \'Guangzhou\',\n          display: \'广州\',\n          search: \'广州\',\n        },\n      ],\n    },\n    {\n      label: \'城市名\',\n      options: [\n        {\n          value: \'Chengdu\',\n          display: \'成都\',\n          search: \'成都\',\n        },\n        {\n          value: \'Shenzhen\',\n          display: \'深圳\',\n          search: \'深圳\',\n        },\n        {\n          value: \'Guangzhou\',\n          display: \'广州\',\n          search: \'广州\',\n        },\n        {\n          value: \'Hangzhou\',\n          display: \'杭州\',\n          search: \'杭州\',\n        },\n      ],\n    },\n  ]\n  return (\n    <>\n      <Dropdown\n        options={options}\n        placeholder={\'Customized Simple Options\'}\n        style={{ width: \'200px\' }}\n      >\n        {options.map(option => {\n          return (\n            <Dropdown.Option key={option.value} option={option}>\n              <span style={{ float: \'left\' }}>{option.value}</span>\n              <span style={{ float: \'right\' }}>\n                {option.value.toUpperCase()}\n              </span>\n            </Dropdown.Option>\n          )\n        })}\n      </Dropdown>\n      <span style={{ display: \'inline-block\', width: \'15px\' }}></span>\n      <Dropdown\n        options={groupOptions}\n        placeholder={\'Customized Group Options\'}\n        style={{ width: \'200px\' }}\n        searchable\n      >\n        {groupOptions.map(group => {\n          return (\n            <Dropdown.OptionGroup key={group.label} label={group.label}>\n              {group.options.map(option => {\n                return (\n                  <Dropdown.Option key={option.value} option={option}>\n                    <span style={{ float: \'left\' }}>{option.display}</span>\n                    <span style={{ float: \'right\' }}>{option.value}</span>\n                  </Dropdown.Option>\n                )\n              })}\n            </Dropdown.OptionGroup>\n          )\n        })}\n      </Dropdown>\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Dropdown,
      DropdownOption,
      Button,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        const options = [{
          value: 'Apple'
        }, {
          value: 'Banana'
        }, {
          value: 'Coconut'
        }];
        const groupOptions = [{
          label: '热门城市',
          options: [{
            value: 'Beijing',
            display: '北京',
            search: '北京'
          }, {
            value: 'Shanghai',
            display: '上海',
            search: '上海'
          }, {
            value: 'Guangzhou',
            display: '广州',
            search: '广州'
          }]
        }, {
          label: '城市名',
          options: [{
            value: 'Chengdu',
            display: '成都',
            search: '成都'
          }, {
            value: 'Shenzhen',
            display: '深圳',
            search: '深圳'
          }, {
            value: 'Guangzhou',
            display: '广州',
            search: '广州'
          }, {
            value: 'Hangzhou',
            display: '杭州',
            search: '杭州'
          }]
        }];
        return <>
        <Dropdown options={options} placeholder={'Customized Simple Options'} style={{
            width: '200px'
          }} mdxType="Dropdown">{options.map(option => {
              return <Dropdown.Option key={option.value} option={option}>
                    <span style={{
                  float: 'left'
                }}>{option.value}</span>
                    <span style={{
                  float: 'right'
                }}>{option.value.toUpperCase()}</span>
                    </Dropdown.Option>;
            })}
        </Dropdown>
        <span style={{
            display: 'inline-block',
            width: '15px'
          }}></span>
        <Dropdown options={groupOptions} placeholder={'Customized Group Options'} style={{
            width: '200px'
          }} searchable mdxType="Dropdown">{groupOptions.map(group => {
              return <Dropdown.OptionGroup key={group.label} label={group.label}>{group.options.map(option => {
                  return <Dropdown.Option key={option.value} option={option}>
                        <span style={{
                      float: 'left'
                    }}>{option.display}</span>
                        <span style={{
                      float: 'right'
                    }}>{option.value}</span>
                      </Dropdown.Option>;
                })}</Dropdown.OptionGroup>;
            })}
        </Dropdown>
    </>;
      }}
    </Playground>
    <h2 {...{
      "id": "onblur"
    }}>{`onBlur`}</h2>
    <Playground __position={13} __code={'() => {\n  const myOptions = [\n    { value: \'Apple\' },\n    { value: \'Banana\' },\n    { value: \'Coconut\' },\n  ]\n  return (\n    <Dropdown\n      options={myOptions}\n      placeholder=\"Select something!\"\n      style={{ width: \'200px\' }}\n      onBlur={console.log}\n    />\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Dropdown,
      DropdownOption,
      Button,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        const myOptions = [{
          value: 'Apple'
        }, {
          value: 'Banana'
        }, {
          value: 'Coconut'
        }];
        return <Dropdown options={myOptions} placeholder="Select something!" style={{
          width: '200px'
        }} onBlur={console.log} mdxType="Dropdown" />;
      }}
    </Playground>
    <h2 {...{
      "id": "onfocus"
    }}>{`onFocus`}</h2>
    <Playground __position={14} __code={'() => {\n  const myOptions = [\n    { value: \'Apple\' },\n    { value: \'Banana\' },\n    { value: \'Coconut\' },\n  ]\n  return (\n    <Dropdown\n      options={myOptions}\n      placeholder=\"Click and see logs!\"\n      style={{ width: \'200px\' }}\n      onFocus={() => console.log(\'onFocus\')}\n    />\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Dropdown,
      DropdownOption,
      Button,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        const myOptions = [{
          value: 'Apple'
        }, {
          value: 'Banana'
        }, {
          value: 'Coconut'
        }];
        return <Dropdown options={myOptions} placeholder="Click and see logs!" style={{
          width: '200px'
        }} onFocus={() => console.log('onFocus')} mdxType="Dropdown" />;
      }}
    </Playground>
    <h2 {...{
      "id": "onclosedropdown"
    }}>{`onCloseDropDown`}</h2>
    <Playground __position={15} __code={'() => {\n  const myOptions = [\n    { value: \'Apple\' },\n    { value: \'Banana\' },\n    { value: \'Coconut\' },\n  ]\n  return (\n    <Dropdown\n      options={myOptions}\n      placeholder=\"Show dropdown, then close dropdown\"\n      style={{ width: \'200px\' }}\n      onCloseDropDown={() => console.log(\'onCloseDropDown\')}\n    />\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Dropdown,
      DropdownOption,
      Button,
      Icon,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        const myOptions = [{
          value: 'Apple'
        }, {
          value: 'Banana'
        }, {
          value: 'Coconut'
        }];
        return <Dropdown options={myOptions} placeholder="Show dropdown, then close dropdown" style={{
          width: '200px'
        }} onCloseDropDown={() => console.log('onCloseDropDown')} mdxType="Dropdown" />;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      